// extracted by mini-css-extract-plugin
export default {"plusBtn":"StudiosList_plusBtn__Rw6Qk","addBtn":"StudiosList_addBtn__vpotQ"};